import React from 'react';
import { IpLogo } from './icons';
import StickyForm from './StickyForm';
function HeroSection({ user }) {
    return (React.createElement("section", { className: "hero-section" },
        React.createElement("div", { className: "hero-background" },
            React.createElement("a", { href: "/", "aria-label": "InspectPoint", className: "logo" },
                React.createElement(IpLogo, null)),
            React.createElement("div", { className: "hero-container" },
                React.createElement("div", { className: "hero-content" },
                    React.createElement("div", { className: "hero-text" },
                        React.createElement("h1", { className: "hero-title" },
                            "Congratulations! ",
                            React.createElement("i", { className: "fa-solid fa-party-horn" })),
                        React.createElement("img", { src: "/immockups.png", alt: "InspectPoint AI Assistant interface showing inspection analysis", className: "devices-mockup" }),
                        React.createElement("div", { className: "hero-description" },
                            React.createElement("p", { className: "hero-subtitle" }, "You've been selected to join a select group of fire safety companies chosen to preview our Inspection Assistant."),
                            React.createElement("p", { className: "hero-details" },
                                React.createElement("strong", null, "Intelligently check your inspections for grammar, completeness, and historical anomalies."),
                                React.createElement("br", null),
                                "This AI-powered assistant streamlines your quality control process, saving you time and guaranteeing",
                                ' ',
                                "consistent, high-quality deliverables to your customers. Schedule your preview today!"))),
                    React.createElement(StickyForm, { user: user }))))));
}
export default HeroSection;
